"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getImageKey = getImageKey;
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _gatsbyImage = _interopRequireDefault(require("gatsby-image"));

var _semanticUiReact = require("semantic-ui-react");

var _gatsbyBackgroundImage = _interopRequireDefault(require("gatsby-background-image"));

var _gatsby = require("../../utils/gatsby");

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        (0, _defineProperty2["default"])(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _createSuper(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct();

  return function _createSuperInternal() {
    var Super = (0, _getPrototypeOf2["default"])(Derived),
        result;

    if (hasNativeReflectConstruct) {
      var NewTarget = (0, _getPrototypeOf2["default"])(this).constructor;
      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return (0, _possibleConstructorReturn2["default"])(this, result);
  };
}

function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;

  try {
    Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}

function getImageKey(image) {
  if (typeof image === 'string') {
    return image;
  }

  if (image.fixed) {
    return image.fixed.src;
  }

  if (image.fluid) {
    return image.fluid.src;
  }

  return null;
}

var Image = /*#__PURE__*/function (_React$PureComponent) {
  (0, _inherits2["default"])(Image, _React$PureComponent);

  var _super = _createSuper(Image);

  function Image() {
    (0, _classCallCheck2["default"])(this, Image);
    return _super.apply(this, arguments);
  }

  (0, _createClass2["default"])(Image, [{
    key: "getImage",
    value: function getImage() {
      var _this$props = this.props,
          imageQuery = _this$props.imageQuery,
          src = _this$props.src;

      if (!!imageQuery && (!!imageQuery.fixed || !!imageQuery.fluid)) {
        return imageQuery;
      }

      if (typeof imageQuery === 'string' && !!imageQuery) {
        return imageQuery;
      }

      return src;
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
          src = _this$props2.src,
          background = _this$props2.background,
          imageQuery = _this$props2.imageQuery,
          altText = _this$props2.altText,
          gatsbyImageProps = _this$props2.gatsbyImageProps,
          children = _this$props2.children,
          extraProps = (0, _objectWithoutProperties2["default"])(_this$props2, ["src", "background", "imageQuery", "altText", "gatsbyImageProps", "children"]);
      var image = this.getImage();

      if (!image) {
        return null;
      }

      if ((0, _gatsby.isGatsbyImage)(image)) {
        var allGatsbyImageProps = _objectSpread(_objectSpread(_objectSpread(_objectSpread({}, extraProps), gatsbyImageProps), image), {}, {
          alt: altText || image.altText
        });

        if (background) {
          return /*#__PURE__*/_react["default"].createElement(_gatsbyBackgroundImage["default"], (0, _extends2["default"])({
            Tag: "div"
          }, allGatsbyImageProps), children);
        }

        return /*#__PURE__*/_react["default"].createElement(_gatsbyImage["default"], allGatsbyImageProps);
      } // Handle simple URL image


      if (background) {
        return /*#__PURE__*/_react["default"].createElement("div", (0, _extends2["default"])({}, extraProps, {
          style: _objectSpread({
            backgroundImage: "url('".concat(image, "')"),
            backgroundPosition: 'center',
            backgroundSize: 'cover'
          }, extraProps.style)
        }), children);
      }

      return /*#__PURE__*/_react["default"].createElement(_semanticUiReact.Image, (0, _extends2["default"])({}, extraProps, {
        src: image,
        alt: altText
      }));
    }
  }]);
  return Image;
}(_react["default"].PureComponent);

var _default = Image;
exports["default"] = _default;
Image.propTypes = {
  src: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].object]),
  background: _propTypes["default"].bool,
  imageQuery: _propTypes["default"].object,
  altText: _propTypes["default"].string,
  gatsbyImageProps: _propTypes["default"].object,
  children: _propTypes["default"].element
};
Image.defaultProps = {
  src: '',
  background: false,
  imageQuery: null,
  altText: '',
  gatsbyImageProps: null,
  children: null
};